<template>
  <div class="page">
  <div class="page-content">
      <div class="content">
          <div v-for="(item,index) in modelUpgradeList" :key="index" class="item">
              <div class="top">
                  <MgJzD :typeId="item.dictType" style="margin-left: 3px;"></MgJzD>
                  <span
                      class="icon-box"
                      :title="'升级介绍：' + item.conditionIntro"
                      style="margin-left: 8px;cursor: pointer"
                  >
<!--                      <Icon color="#606266">-->
                      <!--                        <Refresh />-->
                      <!--                      </Icon>-->
                      <i class="el-icon-info" style="color: #606266;"></i>
                    </span>
              </div>
              <div class="center">
<!--                  <i class="el-icon-question" style="width: 42px;height: 42px;font-size: 42px;margin-right: 8px;color: #2d8cf0"></i>-->
                  <span>
                      {{item.conditionName}}
                  </span>
              </div>
              <div class="bottom">
                  <el-switch
                      v-model="item.isActive"
                      active-color="#13ce66"
                      :active-value="1"
                      :inactive-value="0"
                      inactive-color="#ff4949">
                  </el-switch>
              </div>
          </div>
      </div>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import MgJzD from '@/components/model/modelPlaceUI.vue';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        MgJzD
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetModelUpgradeList();
                    this.getModelUpgradeList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetModelUpgradeList();
                    this.getModelUpgradeList();
                    this.$emit('resetCheckState');
                }
            },
            names: {
                handler(newNames, oldNames) {
                    if(JSON.stringify(oldNames) == '[]'){
                        return
                    }
                    newNames.forEach((name, index) => {
                        if (name !== oldNames[index]) {
                            console.log(`Active of item at index ${index} changed to ${name}`);
                            post(`/model/upgrade/edit`,this.modelUpgradeList[index] ).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetModelUpgradeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                    this.modelUpgradeList[index].isActive = oldNames[index];
                                }
                            });
                        }
                    });
                },
                deep: true,
                immediate: false,
            },
        },
    computed: {
        names() {
            return this.modelUpgradeList.map(item => item.isActive);
        },
    },
    data() {
            return {
                queryForm:{
                     conditionName: '', //升级条件名称
                     conditionType: '', //升级条件类型
                     isActive: '', //是否激活
                     conditionIntro: '', //升级条件介绍
					 dictType: '', //字典类型
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                modelUpgradeState: 'add',
                modelUpgradeStates: {
                    add: '新建升级',
                    check: '查看升级',
                    edit: '修改升级'
                },

                multipleSelection: [],
                modelUpgradeList: [],
                modelUpgrade: {
                    id: '', //ID
                    conditionName: '', //升级条件名称
                    conditionType: '', //升级条件类型
                    isActive: '', //是否激活
                    conditionIntro: '', //升级条件介绍
					dictType: '', //字典类型
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    conditionName: [{ required: true, message: '升级条件名称不能为空', trigger: 'blur' }],
                    conditionType: [{ required: true, message: '升级条件类型不能为空', trigger: 'blur' }],
                    isActive: [{ required: true, message: '是否激活不能为空', trigger: 'blur' }],
                    conditionIntro: [{ required: true, message: '升级条件介绍不能为空', trigger: 'blur' }],
					dictType: [{ required: true, message: '字典类型不能为空', trigger: 'blur' }],
                    createUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    updateUserId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    updateTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    deleteFlag: [{ required: true, message: '不能为空', trigger: 'blur' }],
                },
                auditStatus:[],
            };
        },
        created() {
            this.getModelUpgradeList();
            this.getAuditStatus();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getcttpe(key){
              for(let i = 0; i < this.auditStatus.length; i++){
                  if(this.auditStatus[i].key == key){
                    return this.auditStatus[i].value;
                  }
                }
            },
            getAuditStatus() {
                get('/mpp/utils/getEnum', { enumType: 'model_upgrade_condition' }).then((res) => {
                    this.auditStatus = res.enumList;
                });
            },
            resetModelUpgradeList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.modelUpgradeList = [];
            },
            resetDialog() {
                this.modelUpgradeState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      conditionName: '', //升级条件名称
                      conditionType: '', //升级条件类型
                      isActive: '', //是否激活
                      conditionIntro: '', //升级条件介绍
                };
                this.getModelUpgradeList();
            },
            closeDialog() {
                this.showDialog = false
                this.modelUpgrade = {
                      id: '', //ID
                      conditionName: '', //升级条件名称
                      conditionType: '', //升级条件类型
                      isActive: '', //是否激活
                      conditionIntro: '', //升级条件介绍
                };
            },
            submitForm() {
                if (this.modelUpgradeState == 'add') {
                    this.$refs.modelUpgradeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/upgrade/add`,{ ...this.modelUpgrade }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetModelUpgradeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.modelUpgradeState == 'edit') {
                    this.$refs.modelUpgradeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/model/upgrade/edit`,{ ...this.modelUpgrade }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetModelUpgradeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addModelUpgrade() {
                this.showDialog = true;
                this.modelUpgradeState = 'add';
            },
            checkModelUpgrade(modelUpgradeId) {
                console.log(modelUpgradeId);
                this.currentModelUpgradeId = modelUpgradeId;

                this.getModelUpgradeById();
                this.showDialog = true;
                this.modelUpgradeState = 'check';
            },
            editModelUpgrade(modelUpgradeId) {
                console.log('modelUpgrade', modelUpgradeId);
                if (modelUpgradeId) {
                    this.currentModelUpgradeId = modelUpgradeId;
                    this.getModelUpgradeById();
                } else {
                    this.modelUpgrade = { ...this.modelUpgrade, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.modelUpgradeState = 'edit';
            },
            deleteModelUpgrade(modelUpgradeId) {
                let ids = '';
                if (modelUpgradeId) {
                    ids = modelUpgradeId;
                } else {
                    ids = this.multipleSelection.map((modelUpgrade) => modelUpgrade.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/model/upgrade/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetModelUpgradeList();
                                this.getModelUpgradeList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshModelUpgradeList() {
                this.resetModelUpgradeList();
                this.getModelUpgradeList();
            },
            getModelUpgradeList(query = {}) {
                this.loading = true;
                get(`/model/upgrade/findAll`).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.modelUpgradeList = res.list;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getModelUpgradeById() {
                get(`/model/upgrade/get`,{ id: this.currentModelUpgradeId }).then((res) =>{
                    if(res.success){
                      this.modelUpgrade = { ...this.modelUpgrade, ...res.modelUpgrade };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportModelUpgradeList() {
                //this.btnLoading = true;
                exprotExcel(`/model/upgrade/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/model/upgrade/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/model/upgrade/importData`,formData);
              this.refreshModelUpgradeList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getModelUpgradeList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getModelUpgradeList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.content{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    .item{
        width: 180px;
        height: 120px;
        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
        border-radius: 8px;
        padding: 10px;
        margin-left: 15px;
        margin-bottom: 15px;
        .top{
            display: flex;
            justify-content: flex-end;
            align-content: center;
            align-items: center;
        }
        .center{
            margin-top: 4px;
            height: 42px;
            display: flex;
            span{
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                font-size: 14px;
            }
        }
        .bottom{
            margin-top: 4px;
            display: flex;
            justify-content: flex-end;
        }
    }
}
</style>